import React, { useMemo, useRef } from "react";
import { motion } from "framer-motion";
import { IconButton } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const HorizontalJourneyView = ({
  entries,
  onSelect,
  formatDateForInput,
  iconMap,
  getJourneyIcon,
  expandedIndex,
  setExpandedIndex,
  maxLength,
}) => {
  const scrollerRef = useRef(null);
  const safeEntries = entries || [];
  const sortedEntries = useMemo(() => {
    return [...safeEntries].sort((a, b) => {
      const aDate = new Date(a?.endDate || a?.startDate || 0).getTime();
      const bDate = new Date(b?.endDate || b?.startDate || 0).getTime();
      return bDate - aDate;
    });
  }, [safeEntries]);

  if (safeEntries.length === 0) return null;

  const scrollByCard = (direction) => {
    if (!scrollerRef.current) return;
    const amount = 320;
    scrollerRef.current.scrollBy({
      left: direction === "left" ? -amount : amount,
      behavior: "smooth",
    });
  };

  return (
    <div className="relative w-full">
      <div className="absolute left-12 right-12 top-9 h-0.5 bg-blue-200" />

      <IconButton
        aria-label="Scroll left"
        onClick={() => scrollByCard("left")}
        sx={{
          position: "absolute",
          top: 24,
          left: 0,
          bgcolor: "#fff",
          border: "1px solid #e5e7eb",
          boxShadow: 1,
          zIndex: 2,
        }}
        size="small"
      >
        <ChevronLeftIcon />
      </IconButton>

      <IconButton
        aria-label="Scroll right"
        onClick={() => scrollByCard("right")}
        sx={{
          position: "absolute",
          top: 24,
          right: 0,
          bgcolor: "#fff",
          border: "1px solid #e5e7eb",
          boxShadow: 1,
          zIndex: 2,
        }}
        size="small"
      >
        <ChevronRightIcon />
      </IconButton>

      <div
        ref={scrollerRef}
        className="flex items-start gap-6 overflow-x-auto pb-4 px-10"
      >
        {sortedEntries.map((entry, index) => {
          const isExpanded = expandedIndex === index;
          const plainText = entry.description.replace(/<[^>]*>/g, ""); //so it wont the tags from the text
          const isLong = plainText.length > maxLength;

          return (
            <motion.div
              key={entry._id || index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="min-w-[350px] w-[350px] flex flex-col items-center"
              onClick={() => onSelect(entry)}
            >
              <div className="flex flex-col items-center">
                <div className="w-12 h-12 rounded-full bg-blue-50 border border-blue-200 flex items-center justify-center text-blue-500 text-xl">
                  {getJourneyIcon
                    ? getJourneyIcon(entry.position)
                    : iconMap?.[entry.position] || iconMap?.default}
                </div>
                <div className="w-2.5 h-2.5 rounded-full bg-blue-500 mt-2" />
              </div>

              <div
                className="bg-white mt-4 w-full h-[250px] rounded-xl overflow-y-auto border border-gray-200 shadow-sm p-4 text-left flex flex-col"
              >
                <div className="flex items-center justify-between text-xs text-gray-500 mb-2">
                  <span>{formatDateForInput(entry.startDate)}</span>
                  <span>{formatDateForInput(entry.endDate, "Present")}</span>
                </div>
                <h3 className="font-semibold text-sm text-blue-700">
                  {entry.position}
                </h3>
                {/* <p
                  className={`mt-1 text-gray-700 text-sm ${
                    isExpanded ? "" : "overflow-hidden"
                  }`}
                  style={
                    isExpanded
                      ? undefined
                      : {
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }
                  }
                >
                  {isExpanded || !isLong ? (
                    entry.description
                  ) : (
                    <>
                      {entry.description.slice(0, maxLength)}
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          setExpandedIndex(index);
                        }}
                        className="ml-1 cursor-pointer font-bold text-base text-sky-500 hover:text-sky-600 transition-colors"
                      >
                        ...more
                      </span>
                    </>
                  )}
                </p> */}
                <div className="mt-1">
                  <div
                    className="text-gray-700 text-sm"
                    style={
                      isExpanded
                        ? undefined
                        : {
                          display: "-webkit-box",
                          WebkitLineClamp: 6,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }
                    }
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: entry.description,
                      }}
                    />
                  </div>

                  {isLong && (
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        setExpandedIndex(isExpanded ? null : index);
                      }}
                      className="mt-1 inline-block cursor-pointer font-bold text-sm text-sky-500 hover:text-sky-600 transition-colors"
                    >
                      {isExpanded ? "Show Less" : "Show More"}
                    </span>
                  )}
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default HorizontalJourneyView;